import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';
import { hrScopeGuard } from './core/auth/hr-scope.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: 'set-password',
    loadComponent: () =>
      import('./features/auth/set-password/set-password.component').then(
        (m) => m.SetPasswordComponent
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    canActivate: [authGuard],
    canActivateChild: [hrScopeGuard()],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'inbox',
        loadComponent: () =>
          import('./features/notifications/notifications.component').then(
            (m) => m.NotificationsComponent
          ),
      },
      {
        path: 'timesheet',
        loadComponent: () =>
          import('./features/timesheet/timesheet.component').then(
            (m) => m.TimesheetComponent
          ),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./features/projects/project-list/project-list.component').then(
            (m) => m.ProjectListComponent
          ),
      },
      {
        path: 'projects/new',
        loadComponent: () =>
          import(
            './features/projects/create-project/create-project.component'
          ).then((m) => m.CreateProjectComponent),
      },
      {
        path: 'projects/:projectId/board',
        loadComponent: () =>
          import('./features/board/board.component').then(
            (m) => m.BoardComponent
          ),
      },
      {
        path: 'projects/:projectId/backlog',
        loadComponent: () =>
          import('./features/backlog/backlog.component').then(
            (m) => m.BacklogComponent
          ),
      },
      {
        path: 'projects/:projectId/timeline',
        loadComponent: () =>
          import('./features/timeline/timeline.component').then(
            (m) => m.TimelineComponent
          ),
      },
      {
        path: 'projects/:projectId/releases',
        loadComponent: () =>
          import('./features/releases/releases.component').then(
            (m) => m.ReleasesComponent
          ),
      },
      {
        path: 'projects/:projectId/reports',
        loadComponent: () =>
          import('./features/reports/reports.component').then(
            (m) => m.ReportsComponent
          ),
      },
      {
        path: 'projects/:projectId/timesheet',
        loadComponent: () =>
          import('./features/timesheet/timesheet.component').then(
            (m) => m.TimesheetComponent
          ),
      },
      {
        path: 'projects/:projectId/issues/:id',
        loadComponent: () =>
          import(
            './features/issues/issue-detail/issue-detail.component'
          ).then((m) => m.IssueDetailComponent),
      },
      {
        path: 'users',
        canActivate: [roleGuard('SUPER_ADMIN', 'ADMIN')],
        loadComponent: () =>
          import('./features/users/user-list/user-list.component').then(
            (m) => m.UserListComponent
          ),
      },
      {
        path: 'users/new',
        canActivate: [roleGuard('SUPER_ADMIN', 'ADMIN')],
        loadComponent: () =>
          import('./features/users/add-user/add-user.component').then(
            (m) => m.AddUserComponent
          ),
      },
      {
        path: 'account',
        loadComponent: () =>
          import('./features/account/account.component').then(
            (m) => m.AccountComponent
          ),
      },
      {
        path: 'starred',
        loadComponent: () =>
          import('./features/starred/starred.component').then(
            (m) => m.StarredComponent
          ),
      },
      {
        path: 'projects/:projectId/users',
        loadComponent: () =>
          import('./features/projects/project-users/project-users.component').then(
            (m) => m.ProjectUsersComponent
          ),
      },
      {
        path: 'projects/:projectId/settings',
        loadComponent: () =>
          import('./features/settings/project-settings.component').then(
            (m) => m.ProjectSettingsComponent
          ),
      },
      {
        path: 'leads',
        loadComponent: () =>
          import('./features/leads/lead-list/lead-list.component').then(
            (m) => m.LeadListComponent
          ),
      },
      {
        path: 'leads/board',
        loadComponent: () =>
          import('./features/leads/lead-board/lead-board.component').then(
            (m) => m.LeadBoardComponent
          ),
      },
      {
        path: 'leads/:leadId',
        loadComponent: () =>
          import('./features/leads/lead-detail/lead-detail.component').then(
            (m) => m.LeadDetailComponent
          ),
      },
      {
        path: 'hiring',
        canActivate: [roleGuard('HR', 'ADMIN', 'SUPER_ADMIN', 'MANAGER', 'DEVELOPER')],
        loadComponent: () =>
          import('./features/hiring/hiring-board-list/hiring-board-list.component').then(
            (m) => m.HiringBoardListComponent
          ),
      },
      {
        path: 'hiring/boards/:boardId',
        canActivate: [roleGuard('HR', 'ADMIN', 'SUPER_ADMIN', 'MANAGER', 'DEVELOPER')],
        loadComponent: () =>
          import('./features/hiring/hiring-board-kanban/hiring-board-kanban.component').then(
            (m) => m.HiringBoardKanbanComponent
          ),
      },
      {
        path: 'hiring/boards/:boardId/candidates/:candidateId',
        canActivate: [roleGuard('HR', 'ADMIN', 'SUPER_ADMIN', 'MANAGER', 'DEVELOPER')],
        loadComponent: () =>
          import('./features/hiring/hiring-candidate-detail/hiring-candidate-detail.component').then(
            (m) => m.HiringCandidateDetailComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
